"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _parseFloat2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-float"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
require("core-js/modules/es6.object.to-string.js");
require("core-js/modules/es6.regexp.to-string.js");
require("core-js/modules/es6.array.map.js");
require("core-js/modules/es6.array.slice.js");
require("core-js/modules/es6.regexp.match.js");
require("core-js/modules/es6.regexp.replace.js");
require("core-js/modules/es7.string.pad-start.js");
require("core-js/modules/es6.string.includes.js");
require("core-js/modules/es7.array.includes.js");
require("core-js/modules/es6.function.name.js");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _he = _interopRequireDefault(require("he"));
var _polished = require("polished");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _button = _interopRequireDefault(require("@gravity/button"));
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _link = _interopRequireDefault(require("@gravity/link"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _utils = require("@gravity/utils");
var _config = require("@nucleo/config");
var _jsxFileName = "/codebuild/output/src385608357/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/TsMobileMenu/lib/MobileMenu.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _templateObject10,
  _templateObject11,
  _templateObject12,
  _templateObject13,
  _templateObject14,
  _templateObject15,
  _templateObject16,
  _templateObject17,
  _templateObject18,
  _templateObject19,
  _templateObject20,
  _templateObject21,
  _templateObject22,
  _templateObject23;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_m03nq9vsc() {
  var path = "/codebuild/output/src385608357/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/TsMobileMenu/lib/MobileMenu.js";
  var hash = "b8c981f16f17156dbdfbcb5897b38124c6c83a38";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src385608357/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/TsMobileMenu/lib/MobileMenu.js",
    statementMap: {
      "0": {
        start: {
          line: 15,
          column: 32
        },
        end: {
          line: 15,
          column: 47
        }
      },
      "1": {
        start: {
          line: 17,
          column: 19
        },
        end: {
          line: 17,
          column: 62
        }
      },
      "2": {
        start: {
          line: 17,
          column: 28
        },
        end: {
          line: 17,
          column: 62
        }
      },
      "3": {
        start: {
          line: 18,
          column: 15
        },
        end: {
          line: 39,
          column: 1
        }
      },
      "4": {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 21,
          column: 3
        }
      },
      "5": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 17
        }
      },
      "6": {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 27,
          column: 3
        }
      },
      "7": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 42
        }
      },
      "8": {
        start: {
          line: 25,
          column: 9
        },
        end: {
          line: 27,
          column: 3
        }
      },
      "9": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 95
        }
      },
      "10": {
        start: {
          line: 29,
          column: 2
        },
        end: {
          line: 38,
          column: 16
        }
      },
      "11": {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 36,
          column: 27
        }
      },
      "12": {
        start: {
          line: 41,
          column: 27
        },
        end: {
          line: 41,
          column: 93
        }
      },
      "13": {
        start: {
          line: 41,
          column: 36
        },
        end: {
          line: 41,
          column: 93
        }
      },
      "14": {
        start: {
          line: 43,
          column: 27
        },
        end: {
          line: 44,
          column: 83
        }
      },
      "15": {
        start: {
          line: 44,
          column: 2
        },
        end: {
          line: 44,
          column: 83
        }
      },
      "16": {
        start: {
          line: 46,
          column: 29
        },
        end: {
          line: 46,
          column: 43
        }
      },
      "17": {
        start: {
          line: 47,
          column: 21
        },
        end: {
          line: 47,
          column: 38
        }
      },
      "18": {
        start: {
          line: 48,
          column: 33
        },
        end: {
          line: 48,
          column: 60
        }
      },
      "19": {
        start: {
          line: 49,
          column: 17
        },
        end: {
          line: 51,
          column: 1
        }
      },
      "20": {
        start: {
          line: 53,
          column: 16
        },
        end: {
          line: 90,
          column: 1
        }
      },
      "21": {
        start: {
          line: 67,
          column: 23
        },
        end: {
          line: 67,
          column: 51
        }
      },
      "22": {
        start: {
          line: 88,
          column: 28
        },
        end: {
          line: 88,
          column: 61
        }
      },
      "23": {
        start: {
          line: 92,
          column: 30
        },
        end: {
          line: 100,
          column: 1
        }
      },
      "24": {
        start: {
          line: 102,
          column: 16
        },
        end: {
          line: 119,
          column: 1
        }
      },
      "25": {
        start: {
          line: 111,
          column: 13
        },
        end: {
          line: 117,
          column: 3
        }
      },
      "26": {
        start: {
          line: 121,
          column: 28
        },
        end: {
          line: 130,
          column: 1
        }
      },
      "27": {
        start: {
          line: 122,
          column: 20
        },
        end: {
          line: 122,
          column: 87
        }
      },
      "28": {
        start: {
          line: 132,
          column: 30
        },
        end: {
          line: 140,
          column: 1
        }
      },
      "29": {
        start: {
          line: 136,
          column: 22
        },
        end: {
          line: 136,
          column: 96
        }
      },
      "30": {
        start: {
          line: 142,
          column: 16
        },
        end: {
          line: 149,
          column: 1
        }
      },
      "31": {
        start: {
          line: 151,
          column: 25
        },
        end: {
          line: 154,
          column: 1
        }
      },
      "32": {
        start: {
          line: 153,
          column: 26
        },
        end: {
          line: 153,
          column: 62
        }
      },
      "33": {
        start: {
          line: 156,
          column: 22
        },
        end: {
          line: 162,
          column: 1
        }
      },
      "34": {
        start: {
          line: 164,
          column: 17
        },
        end: {
          line: 166,
          column: 1
        }
      },
      "35": {
        start: {
          line: 168,
          column: 14
        },
        end: {
          line: 178,
          column: 1
        }
      },
      "36": {
        start: {
          line: 170,
          column: 20
        },
        end: {
          line: 170,
          column: 94
        }
      },
      "37": {
        start: {
          line: 174,
          column: 6
        },
        end: {
          line: 176,
          column: 12
        }
      },
      "38": {
        start: {
          line: 180,
          column: 15
        },
        end: {
          line: 192,
          column: 1
        }
      },
      "39": {
        start: {
          line: 194,
          column: 17
        },
        end: {
          line: 209,
          column: 1
        }
      },
      "40": {
        start: {
          line: 196,
          column: 20
        },
        end: {
          line: 196,
          column: 94
        }
      },
      "41": {
        start: {
          line: 200,
          column: 6
        },
        end: {
          line: 202,
          column: 12
        }
      },
      "42": {
        start: {
          line: 211,
          column: 16
        },
        end: {
          line: 218,
          column: 1
        }
      },
      "43": {
        start: {
          line: 216,
          column: 4
        },
        end: {
          line: 216,
          column: 85
        }
      },
      "44": {
        start: {
          line: 220,
          column: 23
        },
        end: {
          line: 230,
          column: 1
        }
      },
      "45": {
        start: {
          line: 221,
          column: 20
        },
        end: {
          line: 221,
          column: 87
        }
      },
      "46": {
        start: {
          line: 226,
          column: 6
        },
        end: {
          line: 228,
          column: 12
        }
      },
      "47": {
        start: {
          line: 232,
          column: 21
        },
        end: {
          line: 240,
          column: 1
        }
      },
      "48": {
        start: {
          line: 242,
          column: 30
        },
        end: {
          line: 248,
          column: 1
        }
      },
      "49": {
        start: {
          line: 249,
          column: 23
        },
        end: {
          line: 249,
          column: 35
        }
      },
      "50": {
        start: {
          line: 251,
          column: 32
        },
        end: {
          line: 253,
          column: 1
        }
      },
      "51": {
        start: {
          line: 256,
          column: 14
        },
        end: {
          line: 256,
          column: 18
        }
      },
      "52": {
        start: {
          line: 258,
          column: 2
        },
        end: {
          line: 266,
          column: 4
        }
      },
      "53": {
        start: {
          line: 259,
          column: 20
        },
        end: {
          line: 259,
          column: 24
        }
      },
      "54": {
        start: {
          line: 261,
          column: 17
        },
        end: {
          line: 261,
          column: 26
        }
      },
      "55": {
        start: {
          line: 262,
          column: 4
        },
        end: {
          line: 262,
          column: 24
        }
      },
      "56": {
        start: {
          line: 263,
          column: 4
        },
        end: {
          line: 265,
          column: 14
        }
      },
      "57": {
        start: {
          line: 264,
          column: 6
        },
        end: {
          line: 264,
          column: 30
        }
      },
      "58": {
        start: {
          line: 271,
          column: 4
        },
        end: {
          line: 271,
          column: 17
        }
      },
      "59": {
        start: {
          line: 272,
          column: 4
        },
        end: {
          line: 274,
          column: 6
        }
      },
      "60": {
        start: {
          line: 275,
          column: 4
        },
        end: {
          line: 275,
          column: 40
        }
      },
      "61": {
        start: {
          line: 276,
          column: 4
        },
        end: {
          line: 276,
          column: 41
        }
      },
      "62": {
        start: {
          line: 277,
          column: 4
        },
        end: {
          line: 277,
          column: 54
        }
      },
      "63": {
        start: {
          line: 278,
          column: 4
        },
        end: {
          line: 278,
          column: 53
        }
      },
      "64": {
        start: {
          line: 279,
          column: 4
        },
        end: {
          line: 279,
          column: 46
        }
      },
      "65": {
        start: {
          line: 280,
          column: 4
        },
        end: {
          line: 280,
          column: 47
        }
      },
      "66": {
        start: {
          line: 281,
          column: 4
        },
        end: {
          line: 281,
          column: 47
        }
      },
      "67": {
        start: {
          line: 282,
          column: 4
        },
        end: {
          line: 282,
          column: 48
        }
      },
      "68": {
        start: {
          line: 283,
          column: 4
        },
        end: {
          line: 283,
          column: 48
        }
      },
      "69": {
        start: {
          line: 284,
          column: 4
        },
        end: {
          line: 284,
          column: 55
        }
      },
      "70": {
        start: {
          line: 285,
          column: 4
        },
        end: {
          line: 285,
          column: 65
        }
      },
      "71": {
        start: {
          line: 289,
          column: 4
        },
        end: {
          line: 289,
          column: 68
        }
      },
      "72": {
        start: {
          line: 290,
          column: 4
        },
        end: {
          line: 290,
          column: 83
        }
      },
      "73": {
        start: {
          line: 291,
          column: 4
        },
        end: {
          line: 291,
          column: 24
        }
      },
      "74": {
        start: {
          line: 295,
          column: 4
        },
        end: {
          line: 295,
          column: 71
        }
      },
      "75": {
        start: {
          line: 296,
          column: 4
        },
        end: {
          line: 296,
          column: 86
        }
      },
      "76": {
        start: {
          line: 300,
          column: 4
        },
        end: {
          line: 300,
          column: 27
        }
      },
      "77": {
        start: {
          line: 304,
          column: 4
        },
        end: {
          line: 304,
          column: 78
        }
      },
      "78": {
        start: {
          line: 308,
          column: 32
        },
        end: {
          line: 308,
          column: 37
        }
      },
      "79": {
        start: {
          line: 309,
          column: 4
        },
        end: {
          line: 313,
          column: 5
        }
      },
      "80": {
        start: {
          line: 310,
          column: 6
        },
        end: {
          line: 312,
          column: 8
        }
      },
      "81": {
        start: {
          line: 311,
          column: 19
        },
        end: {
          line: 311,
          column: 88
        }
      },
      "82": {
        start: {
          line: 314,
          column: 4
        },
        end: {
          line: 321,
          column: 5
        }
      },
      "83": {
        start: {
          line: 320,
          column: 6
        },
        end: {
          line: 320,
          column: 30
        }
      },
      "84": {
        start: {
          line: 324,
          column: 22
        },
        end: {
          line: 377,
          column: 3
        }
      },
      "85": {
        start: {
          line: 325,
          column: 25
        },
        end: {
          line: 325,
          column: 35
        }
      },
      "86": {
        start: {
          line: 326,
          column: 23
        },
        end: {
          line: 326,
          column: 33
        }
      },
      "87": {
        start: {
          line: 328,
          column: 6
        },
        end: {
          line: 328,
          column: 71
        }
      },
      "88": {
        start: {
          line: 330,
          column: 6
        },
        end: {
          line: 330,
          column: 84
        }
      },
      "89": {
        start: {
          line: 339,
          column: 4
        },
        end: {
          line: 376,
          column: 5
        }
      },
      "90": {
        start: {
          line: 340,
          column: 6
        },
        end: {
          line: 347,
          column: 7
        }
      },
      "91": {
        start: {
          line: 341,
          column: 8
        },
        end: {
          line: 346,
          column: 9
        }
      },
      "92": {
        start: {
          line: 343,
          column: 10
        },
        end: {
          line: 345,
          column: 16
        }
      },
      "93": {
        start: {
          line: 344,
          column: 12
        },
        end: {
          line: 344,
          column: 45
        }
      },
      "94": {
        start: {
          line: 348,
          column: 11
        },
        end: {
          line: 376,
          column: 5
        }
      },
      "95": {
        start: {
          line: 349,
          column: 36
        },
        end: {
          line: 349,
          column: 46
        }
      },
      "96": {
        start: {
          line: 356,
          column: 31
        },
        end: {
          line: 356,
          column: 35
        }
      },
      "97": {
        start: {
          line: 357,
          column: 25
        },
        end: {
          line: 357,
          column: 61
        }
      },
      "98": {
        start: {
          line: 358,
          column: 6
        },
        end: {
          line: 368,
          column: 7
        }
      },
      "99": {
        start: {
          line: 359,
          column: 8
        },
        end: {
          line: 359,
          column: 52
        }
      },
      "100": {
        start: {
          line: 360,
          column: 13
        },
        end: {
          line: 368,
          column: 7
        }
      },
      "101": {
        start: {
          line: 361,
          column: 8
        },
        end: {
          line: 361,
          column: 53
        }
      },
      "102": {
        start: {
          line: 362,
          column: 13
        },
        end: {
          line: 368,
          column: 7
        }
      },
      "103": {
        start: {
          line: 363,
          column: 8
        },
        end: {
          line: 363,
          column: 53
        }
      },
      "104": {
        start: {
          line: 364,
          column: 13
        },
        end: {
          line: 368,
          column: 7
        }
      },
      "105": {
        start: {
          line: 365,
          column: 8
        },
        end: {
          line: 365,
          column: 51
        }
      },
      "106": {
        start: {
          line: 367,
          column: 8
        },
        end: {
          line: 367,
          column: 52
        }
      },
      "107": {
        start: {
          line: 370,
          column: 6
        },
        end: {
          line: 375,
          column: 7
        }
      },
      "108": {
        start: {
          line: 372,
          column: 8
        },
        end: {
          line: 374,
          column: 14
        }
      },
      "109": {
        start: {
          line: 373,
          column: 10
        },
        end: {
          line: 373,
          column: 45
        }
      },
      "110": {
        start: {
          line: 379,
          column: 22
        },
        end: {
          line: 388,
          column: 3
        }
      },
      "111": {
        start: {
          line: 380,
          column: 4
        },
        end: {
          line: 387,
          column: 5
        }
      },
      "112": {
        start: {
          line: 381,
          column: 6
        },
        end: {
          line: 386,
          column: 7
        }
      },
      "113": {
        start: {
          line: 383,
          column: 8
        },
        end: {
          line: 385,
          column: 14
        }
      },
      "114": {
        start: {
          line: 384,
          column: 10
        },
        end: {
          line: 384,
          column: 56
        }
      },
      "115": {
        start: {
          line: 390,
          column: 25
        },
        end: {
          line: 400,
          column: 3
        }
      },
      "116": {
        start: {
          line: 392,
          column: 4
        },
        end: {
          line: 399,
          column: 5
        }
      },
      "117": {
        start: {
          line: 393,
          column: 6
        },
        end: {
          line: 398,
          column: 7
        }
      },
      "118": {
        start: {
          line: 395,
          column: 8
        },
        end: {
          line: 397,
          column: 14
        }
      },
      "119": {
        start: {
          line: 396,
          column: 10
        },
        end: {
          line: 396,
          column: 55
        }
      },
      "120": {
        start: {
          line: 402,
          column: 23
        },
        end: {
          line: 403,
          column: 85
        }
      },
      "121": {
        start: {
          line: 403,
          column: 4
        },
        end: {
          line: 403,
          column: 85
        }
      },
      "122": {
        start: {
          line: 406,
          column: 25
        },
        end: {
          line: 406,
          column: 35
        }
      },
      "123": {
        start: {
          line: 407,
          column: 50
        },
        end: {
          line: 407,
          column: 60
        }
      },
      "124": {
        start: {
          line: 408,
          column: 24
        },
        end: {
          line: 408,
          column: 44
        }
      },
      "125": {
        start: {
          line: 409,
          column: 23
        },
        end: {
          line: 409,
          column: 59
        }
      },
      "126": {
        start: {
          line: 410,
          column: 24
        },
        end: {
          line: 410,
          column: 83
        }
      },
      "127": {
        start: {
          line: 410,
          column: 67
        },
        end: {
          line: 410,
          column: 82
        }
      },
      "128": {
        start: {
          line: 411,
          column: 20
        },
        end: {
          line: 411,
          column: 44
        }
      },
      "129": {
        start: {
          line: 413,
          column: 20
        },
        end: {
          line: 416,
          column: 5
        }
      },
      "130": {
        start: {
          line: 418,
          column: 4
        },
        end: {
          line: 641,
          column: 6
        }
      },
      "131": {
        start: {
          line: 611,
          column: 35
        },
        end: {
          line: 611,
          column: 79
        }
      },
      "132": {
        start: {
          line: 612,
          column: 16
        },
        end: {
          line: 622,
          column: 18
        }
      },
      "133": {
        start: {
          line: 645,
          column: 0
        },
        end: {
          line: 666,
          column: 2
        }
      },
      "134": {
        start: {
          line: 668,
          column: 0
        },
        end: {
          line: 676,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 17,
            column: 19
          },
          end: {
            line: 17,
            column: 20
          }
        },
        loc: {
          start: {
            line: 17,
            column: 28
          },
          end: {
            line: 17,
            column: 62
          }
        },
        line: 17
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 18,
            column: 15
          },
          end: {
            line: 18,
            column: 16
          }
        },
        loc: {
          start: {
            line: 18,
            column: 24
          },
          end: {
            line: 39,
            column: 1
          }
        },
        line: 18
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 32,
            column: 9
          },
          end: {
            line: 32,
            column: 10
          }
        },
        loc: {
          start: {
            line: 33,
            column: 6
          },
          end: {
            line: 36,
            column: 27
          }
        },
        line: 33
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 41,
            column: 27
          },
          end: {
            line: 41,
            column: 28
          }
        },
        loc: {
          start: {
            line: 41,
            column: 36
          },
          end: {
            line: 41,
            column: 93
          }
        },
        line: 41
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 43,
            column: 27
          },
          end: {
            line: 43,
            column: 28
          }
        },
        loc: {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 44,
            column: 83
          }
        },
        line: 44
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 67,
            column: 13
          },
          end: {
            line: 67,
            column: 14
          }
        },
        loc: {
          start: {
            line: 67,
            column: 23
          },
          end: {
            line: 67,
            column: 51
          }
        },
        line: 67
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 88,
            column: 18
          },
          end: {
            line: 88,
            column: 19
          }
        },
        loc: {
          start: {
            line: 88,
            column: 28
          },
          end: {
            line: 88,
            column: 61
          }
        },
        line: 88
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 111,
            column: 4
          },
          end: {
            line: 111,
            column: 5
          }
        },
        loc: {
          start: {
            line: 111,
            column: 13
          },
          end: {
            line: 117,
            column: 3
          }
        },
        line: 111
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 122,
            column: 11
          },
          end: {
            line: 122,
            column: 12
          }
        },
        loc: {
          start: {
            line: 122,
            column: 20
          },
          end: {
            line: 122,
            column: 87
          }
        },
        line: 122
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 136,
            column: 13
          },
          end: {
            line: 136,
            column: 14
          }
        },
        loc: {
          start: {
            line: 136,
            column: 22
          },
          end: {
            line: 136,
            column: 96
          }
        },
        line: 136
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 153,
            column: 16
          },
          end: {
            line: 153,
            column: 17
          }
        },
        loc: {
          start: {
            line: 153,
            column: 26
          },
          end: {
            line: 153,
            column: 62
          }
        },
        line: 153
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 170,
            column: 11
          },
          end: {
            line: 170,
            column: 12
          }
        },
        loc: {
          start: {
            line: 170,
            column: 20
          },
          end: {
            line: 170,
            column: 94
          }
        },
        line: 170
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 173,
            column: 13
          },
          end: {
            line: 173,
            column: 14
          }
        },
        loc: {
          start: {
            line: 174,
            column: 6
          },
          end: {
            line: 176,
            column: 12
          }
        },
        line: 174
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 196,
            column: 11
          },
          end: {
            line: 196,
            column: 12
          }
        },
        loc: {
          start: {
            line: 196,
            column: 20
          },
          end: {
            line: 196,
            column: 94
          }
        },
        line: 196
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 199,
            column: 13
          },
          end: {
            line: 199,
            column: 14
          }
        },
        loc: {
          start: {
            line: 200,
            column: 6
          },
          end: {
            line: 202,
            column: 12
          }
        },
        line: 200
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 215,
            column: 11
          },
          end: {
            line: 215,
            column: 12
          }
        },
        loc: {
          start: {
            line: 216,
            column: 4
          },
          end: {
            line: 216,
            column: 85
          }
        },
        line: 216
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 221,
            column: 11
          },
          end: {
            line: 221,
            column: 12
          }
        },
        loc: {
          start: {
            line: 221,
            column: 20
          },
          end: {
            line: 221,
            column: 87
          }
        },
        line: 221
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 225,
            column: 13
          },
          end: {
            line: 225,
            column: 14
          }
        },
        loc: {
          start: {
            line: 226,
            column: 6
          },
          end: {
            line: 228,
            column: 12
          }
        },
        line: 226
      },
      "18": {
        name: "debounce",
        decl: {
          start: {
            line: 255,
            column: 9
          },
          end: {
            line: 255,
            column: 17
          }
        },
        loc: {
          start: {
            line: 255,
            column: 29
          },
          end: {
            line: 267,
            column: 1
          }
        },
        line: 255
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 258,
            column: 9
          },
          end: {
            line: 258,
            column: 10
          }
        },
        loc: {
          start: {
            line: 258,
            column: 20
          },
          end: {
            line: 266,
            column: 3
          }
        },
        line: 258
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 263,
            column: 23
          },
          end: {
            line: 263,
            column: 24
          }
        },
        loc: {
          start: {
            line: 263,
            column: 29
          },
          end: {
            line: 265,
            column: 5
          }
        },
        line: 263
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 270,
            column: 2
          },
          end: {
            line: 270,
            column: 3
          }
        },
        loc: {
          start: {
            line: 270,
            column: 21
          },
          end: {
            line: 286,
            column: 3
          }
        },
        line: 270
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 288,
            column: 2
          },
          end: {
            line: 288,
            column: 3
          }
        },
        loc: {
          start: {
            line: 288,
            column: 22
          },
          end: {
            line: 292,
            column: 3
          }
        },
        line: 288
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 294,
            column: 2
          },
          end: {
            line: 294,
            column: 3
          }
        },
        loc: {
          start: {
            line: 294,
            column: 25
          },
          end: {
            line: 297,
            column: 3
          }
        },
        line: 294
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 299,
            column: 2
          },
          end: {
            line: 299,
            column: 3
          }
        },
        loc: {
          start: {
            line: 299,
            column: 22
          },
          end: {
            line: 301,
            column: 3
          }
        },
        line: 299
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 303,
            column: 2
          },
          end: {
            line: 303,
            column: 3
          }
        },
        loc: {
          start: {
            line: 303,
            column: 17
          },
          end: {
            line: 305,
            column: 3
          }
        },
        line: 303
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 307,
            column: 2
          },
          end: {
            line: 307,
            column: 3
          }
        },
        loc: {
          start: {
            line: 307,
            column: 23
          },
          end: {
            line: 322,
            column: 3
          }
        },
        line: 307
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 311,
            column: 8
          },
          end: {
            line: 311,
            column: 9
          }
        },
        loc: {
          start: {
            line: 311,
            column: 19
          },
          end: {
            line: 311,
            column: 88
          }
        },
        line: 311
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 324,
            column: 22
          },
          end: {
            line: 324,
            column: 23
          }
        },
        loc: {
          start: {
            line: 324,
            column: 31
          },
          end: {
            line: 377,
            column: 3
          }
        },
        line: 324
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 343,
            column: 21
          },
          end: {
            line: 343,
            column: 22
          }
        },
        loc: {
          start: {
            line: 343,
            column: 27
          },
          end: {
            line: 345,
            column: 11
          }
        },
        line: 343
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 372,
            column: 19
          },
          end: {
            line: 372,
            column: 20
          }
        },
        loc: {
          start: {
            line: 372,
            column: 25
          },
          end: {
            line: 374,
            column: 9
          }
        },
        line: 372
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 379,
            column: 22
          },
          end: {
            line: 379,
            column: 23
          }
        },
        loc: {
          start: {
            line: 379,
            column: 31
          },
          end: {
            line: 388,
            column: 3
          }
        },
        line: 379
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 383,
            column: 19
          },
          end: {
            line: 383,
            column: 20
          }
        },
        loc: {
          start: {
            line: 383,
            column: 25
          },
          end: {
            line: 385,
            column: 9
          }
        },
        line: 383
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 390,
            column: 25
          },
          end: {
            line: 390,
            column: 26
          }
        },
        loc: {
          start: {
            line: 390,
            column: 34
          },
          end: {
            line: 400,
            column: 3
          }
        },
        line: 390
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 395,
            column: 19
          },
          end: {
            line: 395,
            column: 20
          }
        },
        loc: {
          start: {
            line: 395,
            column: 25
          },
          end: {
            line: 397,
            column: 9
          }
        },
        line: 395
      },
      "35": {
        name: "(anonymous_35)",
        decl: {
          start: {
            line: 402,
            column: 23
          },
          end: {
            line: 402,
            column: 24
          }
        },
        loc: {
          start: {
            line: 403,
            column: 4
          },
          end: {
            line: 403,
            column: 85
          }
        },
        line: 403
      },
      "36": {
        name: "(anonymous_36)",
        decl: {
          start: {
            line: 405,
            column: 2
          },
          end: {
            line: 405,
            column: 3
          }
        },
        loc: {
          start: {
            line: 405,
            column: 11
          },
          end: {
            line: 642,
            column: 3
          }
        },
        line: 405
      },
      "37": {
        name: "(anonymous_37)",
        decl: {
          start: {
            line: 410,
            column: 57
          },
          end: {
            line: 410,
            column: 58
          }
        },
        loc: {
          start: {
            line: 410,
            column: 67
          },
          end: {
            line: 410,
            column: 82
          }
        },
        line: 410
      },
      "38": {
        name: "(anonymous_38)",
        decl: {
          start: {
            line: 609,
            column: 31
          },
          end: {
            line: 609,
            column: 32
          }
        },
        loc: {
          start: {
            line: 609,
            column: 48
          },
          end: {
            line: 623,
            column: 15
          }
        },
        line: 609
      },
      "39": {
        name: "(anonymous_39)",
        decl: {
          start: {
            line: 674,
            column: 14
          },
          end: {
            line: 674,
            column: 15
          }
        },
        loc: {
          start: {
            line: 674,
            column: 20
          },
          end: {
            line: 674,
            column: 22
          }
        },
        line: 674
      },
      "40": {
        name: "(anonymous_40)",
        decl: {
          start: {
            line: 675,
            column: 17
          },
          end: {
            line: 675,
            column: 18
          }
        },
        loc: {
          start: {
            line: 675,
            column: 23
          },
          end: {
            line: 675,
            column: 25
          }
        },
        line: 675
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 17,
            column: 28
          },
          end: {
            line: 17,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 17,
            column: 28
          },
          end: {
            line: 17,
            column: 33
          }
        }, {
          start: {
            line: 17,
            column: 37
          },
          end: {
            line: 17,
            column: 62
          }
        }],
        line: 17
      },
      "1": {
        loc: {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 19
      },
      "2": {
        loc: {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        }, {
          start: {
            line: 25,
            column: 9
          },
          end: {
            line: 27,
            column: 3
          }
        }],
        line: 23
      },
      "3": {
        loc: {
          start: {
            line: 25,
            column: 9
          },
          end: {
            line: 27,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 25,
            column: 9
          },
          end: {
            line: 27,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 25
      },
      "4": {
        loc: {
          start: {
            line: 33,
            column: 7
          },
          end: {
            line: 33,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 33,
            column: 17
          },
          end: {
            line: 33,
            column: 48
          }
        }, {
          start: {
            line: 33,
            column: 51
          },
          end: {
            line: 33,
            column: 64
          }
        }],
        line: 33
      },
      "5": {
        loc: {
          start: {
            line: 41,
            column: 36
          },
          end: {
            line: 41,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 41,
            column: 37
          },
          end: {
            line: 41,
            column: 48
          }
        }, {
          start: {
            line: 41,
            column: 52
          },
          end: {
            line: 41,
            column: 79
          }
        }, {
          start: {
            line: 41,
            column: 84
          },
          end: {
            line: 41,
            column: 93
          }
        }],
        line: 41
      },
      "6": {
        loc: {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 44,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 44,
            column: 3
          },
          end: {
            line: 44,
            column: 23
          }
        }, {
          start: {
            line: 44,
            column: 27
          },
          end: {
            line: 44,
            column: 57
          }
        }, {
          start: {
            line: 44,
            column: 62
          },
          end: {
            line: 44,
            column: 83
          }
        }],
        line: 44
      },
      "7": {
        loc: {
          start: {
            line: 67,
            column: 23
          },
          end: {
            line: 67,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 67,
            column: 36
          },
          end: {
            line: 67,
            column: 42
          }
        }, {
          start: {
            line: 67,
            column: 45
          },
          end: {
            line: 67,
            column: 51
          }
        }],
        line: 67
      },
      "8": {
        loc: {
          start: {
            line: 88,
            column: 28
          },
          end: {
            line: 88,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 88,
            column: 41
          },
          end: {
            line: 88,
            column: 50
          }
        }, {
          start: {
            line: 88,
            column: 53
          },
          end: {
            line: 88,
            column: 61
          }
        }],
        line: 88
      },
      "9": {
        loc: {
          start: {
            line: 112,
            column: 18
          },
          end: {
            line: 116,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 112,
            column: 18
          },
          end: {
            line: 112,
            column: 29
          }
        }, {
          start: {
            line: 113,
            column: 6
          },
          end: {
            line: 116,
            column: 7
          }
        }],
        line: 112
      },
      "10": {
        loc: {
          start: {
            line: 115,
            column: 8
          },
          end: {
            line: 115,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 115,
            column: 8
          },
          end: {
            line: 115,
            column: 52
          }
        }, {
          start: {
            line: 115,
            column: 56
          },
          end: {
            line: 115,
            column: 88
          }
        }],
        line: 115
      },
      "11": {
        loc: {
          start: {
            line: 122,
            column: 20
          },
          end: {
            line: 122,
            column: 87
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 122,
            column: 21
          },
          end: {
            line: 122,
            column: 32
          }
        }, {
          start: {
            line: 122,
            column: 36
          },
          end: {
            line: 122,
            column: 61
          }
        }, {
          start: {
            line: 122,
            column: 66
          },
          end: {
            line: 122,
            column: 87
          }
        }],
        line: 122
      },
      "12": {
        loc: {
          start: {
            line: 136,
            column: 22
          },
          end: {
            line: 136,
            column: 96
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 136,
            column: 23
          },
          end: {
            line: 136,
            column: 34
          }
        }, {
          start: {
            line: 136,
            column: 38
          },
          end: {
            line: 136,
            column: 70
          }
        }, {
          start: {
            line: 136,
            column: 75
          },
          end: {
            line: 136,
            column: 96
          }
        }],
        line: 136
      },
      "13": {
        loc: {
          start: {
            line: 153,
            column: 26
          },
          end: {
            line: 153,
            column: 62
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 153,
            column: 45
          },
          end: {
            line: 153,
            column: 53
          }
        }, {
          start: {
            line: 153,
            column: 56
          },
          end: {
            line: 153,
            column: 62
          }
        }],
        line: 153
      },
      "14": {
        loc: {
          start: {
            line: 170,
            column: 20
          },
          end: {
            line: 170,
            column: 94
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 170,
            column: 21
          },
          end: {
            line: 170,
            column: 32
          }
        }, {
          start: {
            line: 170,
            column: 36
          },
          end: {
            line: 170,
            column: 68
          }
        }, {
          start: {
            line: 170,
            column: 73
          },
          end: {
            line: 170,
            column: 94
          }
        }],
        line: 170
      },
      "15": {
        loc: {
          start: {
            line: 174,
            column: 6
          },
          end: {
            line: 176,
            column: 12
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 174,
            column: 7
          },
          end: {
            line: 174,
            column: 25
          }
        }, {
          start: {
            line: 174,
            column: 29
          },
          end: {
            line: 174,
            column: 63
          }
        }, {
          start: {
            line: 175,
            column: 6
          },
          end: {
            line: 175,
            column: 27
          }
        }, {
          start: {
            line: 176,
            column: 6
          },
          end: {
            line: 176,
            column: 12
          }
        }],
        line: 174
      },
      "16": {
        loc: {
          start: {
            line: 196,
            column: 20
          },
          end: {
            line: 196,
            column: 94
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 196,
            column: 21
          },
          end: {
            line: 196,
            column: 32
          }
        }, {
          start: {
            line: 196,
            column: 36
          },
          end: {
            line: 196,
            column: 68
          }
        }, {
          start: {
            line: 196,
            column: 73
          },
          end: {
            line: 196,
            column: 94
          }
        }],
        line: 196
      },
      "17": {
        loc: {
          start: {
            line: 200,
            column: 6
          },
          end: {
            line: 202,
            column: 12
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 200,
            column: 7
          },
          end: {
            line: 200,
            column: 25
          }
        }, {
          start: {
            line: 200,
            column: 29
          },
          end: {
            line: 200,
            column: 63
          }
        }, {
          start: {
            line: 201,
            column: 6
          },
          end: {
            line: 201,
            column: 27
          }
        }, {
          start: {
            line: 202,
            column: 6
          },
          end: {
            line: 202,
            column: 12
          }
        }],
        line: 200
      },
      "18": {
        loc: {
          start: {
            line: 216,
            column: 4
          },
          end: {
            line: 216,
            column: 85
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 216,
            column: 4
          },
          end: {
            line: 216,
            column: 25
          }
        }, {
          start: {
            line: 216,
            column: 30
          },
          end: {
            line: 216,
            column: 50
          }
        }, {
          start: {
            line: 216,
            column: 54
          },
          end: {
            line: 216,
            column: 84
          }
        }],
        line: 216
      },
      "19": {
        loc: {
          start: {
            line: 221,
            column: 20
          },
          end: {
            line: 221,
            column: 87
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 221,
            column: 21
          },
          end: {
            line: 221,
            column: 32
          }
        }, {
          start: {
            line: 221,
            column: 36
          },
          end: {
            line: 221,
            column: 61
          }
        }, {
          start: {
            line: 221,
            column: 66
          },
          end: {
            line: 221,
            column: 87
          }
        }],
        line: 221
      },
      "20": {
        loc: {
          start: {
            line: 226,
            column: 6
          },
          end: {
            line: 228,
            column: 12
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 226,
            column: 7
          },
          end: {
            line: 226,
            column: 25
          }
        }, {
          start: {
            line: 226,
            column: 29
          },
          end: {
            line: 226,
            column: 63
          }
        }, {
          start: {
            line: 227,
            column: 6
          },
          end: {
            line: 227,
            column: 27
          }
        }, {
          start: {
            line: 228,
            column: 6
          },
          end: {
            line: 228,
            column: 12
          }
        }],
        line: 226
      },
      "21": {
        loc: {
          start: {
            line: 237,
            column: 13
          },
          end: {
            line: 237,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 237,
            column: 13
          },
          end: {
            line: 237,
            column: 31
          }
        }, {
          start: {
            line: 237,
            column: 35
          },
          end: {
            line: 237,
            column: 41
          }
        }],
        line: 237
      },
      "22": {
        loc: {
          start: {
            line: 304,
            column: 52
          },
          end: {
            line: 304,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 304,
            column: 52
          },
          end: {
            line: 304,
            column: 64
          }
        }, {
          start: {
            line: 304,
            column: 68
          },
          end: {
            line: 304,
            column: 73
          }
        }],
        line: 304
      },
      "23": {
        loc: {
          start: {
            line: 309,
            column: 4
          },
          end: {
            line: 313,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 309,
            column: 4
          },
          end: {
            line: 313,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 309
      },
      "24": {
        loc: {
          start: {
            line: 309,
            column: 8
          },
          end: {
            line: 309,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 309,
            column: 8
          },
          end: {
            line: 309,
            column: 18
          }
        }, {
          start: {
            line: 309,
            column: 22
          },
          end: {
            line: 309,
            column: 43
          }
        }],
        line: 309
      },
      "25": {
        loc: {
          start: {
            line: 311,
            column: 19
          },
          end: {
            line: 311,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 311,
            column: 19
          },
          end: {
            line: 311,
            column: 36
          }
        }, {
          start: {
            line: 311,
            column: 40
          },
          end: {
            line: 311,
            column: 88
          }
        }],
        line: 311
      },
      "26": {
        loc: {
          start: {
            line: 314,
            column: 4
          },
          end: {
            line: 321,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 314,
            column: 4
          },
          end: {
            line: 321,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 314
      },
      "27": {
        loc: {
          start: {
            line: 315,
            column: 6
          },
          end: {
            line: 318,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 315,
            column: 6
          },
          end: {
            line: 315,
            column: 21
          }
        }, {
          start: {
            line: 316,
            column: 6
          },
          end: {
            line: 316,
            column: 21
          }
        }, {
          start: {
            line: 317,
            column: 6
          },
          end: {
            line: 317,
            column: 53
          }
        }, {
          start: {
            line: 318,
            column: 6
          },
          end: {
            line: 318,
            column: 28
          }
        }],
        line: 315
      },
      "28": {
        loc: {
          start: {
            line: 328,
            column: 6
          },
          end: {
            line: 328,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 328,
            column: 6
          },
          end: {
            line: 328,
            column: 12
          }
        }, {
          start: {
            line: 328,
            column: 16
          },
          end: {
            line: 328,
            column: 29
          }
        }, {
          start: {
            line: 328,
            column: 33
          },
          end: {
            line: 328,
            column: 71
          }
        }],
        line: 328
      },
      "29": {
        loc: {
          start: {
            line: 330,
            column: 6
          },
          end: {
            line: 330,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 330,
            column: 6
          },
          end: {
            line: 330,
            column: 12
          }
        }, {
          start: {
            line: 330,
            column: 16
          },
          end: {
            line: 330,
            column: 36
          }
        }, {
          start: {
            line: 330,
            column: 40
          },
          end: {
            line: 330,
            column: 84
          }
        }],
        line: 330
      },
      "30": {
        loc: {
          start: {
            line: 339,
            column: 4
          },
          end: {
            line: 376,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 339,
            column: 4
          },
          end: {
            line: 376,
            column: 5
          }
        }, {
          start: {
            line: 348,
            column: 11
          },
          end: {
            line: 376,
            column: 5
          }
        }],
        line: 339
      },
      "31": {
        loc: {
          start: {
            line: 340,
            column: 6
          },
          end: {
            line: 347,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 340,
            column: 6
          },
          end: {
            line: 347,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 340
      },
      "32": {
        loc: {
          start: {
            line: 340,
            column: 10
          },
          end: {
            line: 340,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 340,
            column: 10
          },
          end: {
            line: 340,
            column: 25
          }
        }, {
          start: {
            line: 340,
            column: 29
          },
          end: {
            line: 340,
            column: 59
          }
        }],
        line: 340
      },
      "33": {
        loc: {
          start: {
            line: 341,
            column: 8
          },
          end: {
            line: 346,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 341,
            column: 8
          },
          end: {
            line: 346,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 341
      },
      "34": {
        loc: {
          start: {
            line: 348,
            column: 11
          },
          end: {
            line: 376,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 348,
            column: 11
          },
          end: {
            line: 376,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 348
      },
      "35": {
        loc: {
          start: {
            line: 348,
            column: 15
          },
          end: {
            line: 348,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 348,
            column: 15
          },
          end: {
            line: 348,
            column: 23
          }
        }, {
          start: {
            line: 348,
            column: 27
          },
          end: {
            line: 348,
            column: 41
          }
        }, {
          start: {
            line: 348,
            column: 45
          },
          end: {
            line: 348,
            column: 75
          }
        }],
        line: 348
      },
      "36": {
        loc: {
          start: {
            line: 357,
            column: 25
          },
          end: {
            line: 357,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 357,
            column: 25
          },
          end: {
            line: 357,
            column: 29
          }
        }, {
          start: {
            line: 357,
            column: 33
          },
          end: {
            line: 357,
            column: 61
          }
        }],
        line: 357
      },
      "37": {
        loc: {
          start: {
            line: 358,
            column: 6
          },
          end: {
            line: 368,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 358,
            column: 6
          },
          end: {
            line: 368,
            column: 7
          }
        }, {
          start: {
            line: 360,
            column: 13
          },
          end: {
            line: 368,
            column: 7
          }
        }],
        line: 358
      },
      "38": {
        loc: {
          start: {
            line: 358,
            column: 10
          },
          end: {
            line: 358,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 358,
            column: 10
          },
          end: {
            line: 358,
            column: 21
          }
        }, {
          start: {
            line: 358,
            column: 25
          },
          end: {
            line: 358,
            column: 47
          }
        }],
        line: 358
      },
      "39": {
        loc: {
          start: {
            line: 360,
            column: 13
          },
          end: {
            line: 368,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 360,
            column: 13
          },
          end: {
            line: 368,
            column: 7
          }
        }, {
          start: {
            line: 362,
            column: 13
          },
          end: {
            line: 368,
            column: 7
          }
        }],
        line: 360
      },
      "40": {
        loc: {
          start: {
            line: 362,
            column: 13
          },
          end: {
            line: 368,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 362,
            column: 13
          },
          end: {
            line: 368,
            column: 7
          }
        }, {
          start: {
            line: 364,
            column: 13
          },
          end: {
            line: 368,
            column: 7
          }
        }],
        line: 362
      },
      "41": {
        loc: {
          start: {
            line: 364,
            column: 13
          },
          end: {
            line: 368,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 364,
            column: 13
          },
          end: {
            line: 368,
            column: 7
          }
        }, {
          start: {
            line: 366,
            column: 13
          },
          end: {
            line: 368,
            column: 7
          }
        }],
        line: 364
      },
      "42": {
        loc: {
          start: {
            line: 370,
            column: 6
          },
          end: {
            line: 375,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 370,
            column: 6
          },
          end: {
            line: 375,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 370
      },
      "43": {
        loc: {
          start: {
            line: 380,
            column: 4
          },
          end: {
            line: 387,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 380,
            column: 4
          },
          end: {
            line: 387,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 380
      },
      "44": {
        loc: {
          start: {
            line: 380,
            column: 8
          },
          end: {
            line: 380,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 380,
            column: 8
          },
          end: {
            line: 380,
            column: 22
          }
        }, {
          start: {
            line: 380,
            column: 26
          },
          end: {
            line: 380,
            column: 56
          }
        }],
        line: 380
      },
      "45": {
        loc: {
          start: {
            line: 381,
            column: 6
          },
          end: {
            line: 386,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 381,
            column: 6
          },
          end: {
            line: 386,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 381
      },
      "46": {
        loc: {
          start: {
            line: 392,
            column: 4
          },
          end: {
            line: 399,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 392,
            column: 4
          },
          end: {
            line: 399,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 392
      },
      "47": {
        loc: {
          start: {
            line: 392,
            column: 8
          },
          end: {
            line: 392,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 392,
            column: 8
          },
          end: {
            line: 392,
            column: 23
          }
        }, {
          start: {
            line: 392,
            column: 27
          },
          end: {
            line: 392,
            column: 57
          }
        }],
        line: 392
      },
      "48": {
        loc: {
          start: {
            line: 393,
            column: 6
          },
          end: {
            line: 398,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 393,
            column: 6
          },
          end: {
            line: 398,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 393
      },
      "49": {
        loc: {
          start: {
            line: 409,
            column: 23
          },
          end: {
            line: 409,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 409,
            column: 23
          },
          end: {
            line: 409,
            column: 27
          }
        }, {
          start: {
            line: 409,
            column: 31
          },
          end: {
            line: 409,
            column: 59
          }
        }],
        line: 409
      },
      "50": {
        loc: {
          start: {
            line: 411,
            column: 20
          },
          end: {
            line: 411,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 411,
            column: 20
          },
          end: {
            line: 411,
            column: 30
          }
        }, {
          start: {
            line: 411,
            column: 34
          },
          end: {
            line: 411,
            column: 44
          }
        }],
        line: 411
      },
      "51": {
        loc: {
          start: {
            line: 423,
            column: 15
          },
          end: {
            line: 423,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 423,
            column: 15
          },
          end: {
            line: 423,
            column: 40
          }
        }, {
          start: {
            line: 423,
            column: 44
          },
          end: {
            line: 423,
            column: 64
          }
        }],
        line: 423
      },
      "52": {
        loc: {
          start: {
            line: 436,
            column: 13
          },
          end: {
            line: 452,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 436,
            column: 13
          },
          end: {
            line: 436,
            column: 24
          }
        }, {
          start: {
            line: 437,
            column: 14
          },
          end: {
            line: 451,
            column: 30
          }
        }],
        line: 436
      },
      "53": {
        loc: {
          start: {
            line: 447,
            column: 31
          },
          end: {
            line: 447,
            column: 90
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 447,
            column: 58
          },
          end: {
            line: 447,
            column: 83
          }
        }, {
          start: {
            line: 447,
            column: 86
          },
          end: {
            line: 447,
            column: 90
          }
        }],
        line: 447
      },
      "54": {
        loc: {
          start: {
            line: 453,
            column: 13
          },
          end: {
            line: 467,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 453,
            column: 13
          },
          end: {
            line: 453,
            column: 20
          }
        }, {
          start: {
            line: 454,
            column: 14
          },
          end: {
            line: 466,
            column: 24
          }
        }],
        line: 453
      },
      "55": {
        loc: {
          start: {
            line: 468,
            column: 13
          },
          end: {
            line: 606,
            column: 15
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 468,
            column: 13
          },
          end: {
            line: 468,
            column: 23
          }
        }, {
          start: {
            line: 469,
            column: 14
          },
          end: {
            line: 469,
            column: 22
          }
        }, {
          start: {
            line: 470,
            column: 16
          },
          end: {
            line: 605,
            column: 26
          }
        }],
        line: 468
      },
      "56": {
        loc: {
          start: {
            line: 482,
            column: 23
          },
          end: {
            line: 482,
            column: 97
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 482,
            column: 23
          },
          end: {
            line: 482,
            column: 41
          }
        }, {
          start: {
            line: 482,
            column: 45
          },
          end: {
            line: 482,
            column: 97
          }
        }],
        line: 482
      },
      "57": {
        loc: {
          start: {
            line: 483,
            column: 23
          },
          end: {
            line: 483,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 483,
            column: 23
          },
          end: {
            line: 483,
            column: 42
          }
        }, {
          start: {
            line: 483,
            column: 46
          },
          end: {
            line: 483,
            column: 79
          }
        }],
        line: 483
      },
      "58": {
        loc: {
          start: {
            line: 486,
            column: 19
          },
          end: {
            line: 500,
            column: 21
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 486,
            column: 19
          },
          end: {
            line: 486,
            column: 32
          }
        }, {
          start: {
            line: 487,
            column: 20
          },
          end: {
            line: 487,
            column: 55
          }
        }, {
          start: {
            line: 488,
            column: 20
          },
          end: {
            line: 488,
            column: 30
          }
        }, {
          start: {
            line: 489,
            column: 22
          },
          end: {
            line: 499,
            column: 48
          }
        }],
        line: 486
      },
      "59": {
        loc: {
          start: {
            line: 510,
            column: 19
          },
          end: {
            line: 518,
            column: 21
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 510,
            column: 19
          },
          end: {
            line: 510,
            column: 32
          }
        }, {
          start: {
            line: 511,
            column: 20
          },
          end: {
            line: 511,
            column: 55
          }
        }, {
          start: {
            line: 512,
            column: 22
          },
          end: {
            line: 517,
            column: 33
          }
        }],
        line: 510
      },
      "60": {
        loc: {
          start: {
            line: 525,
            column: 19
          },
          end: {
            line: 525,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 525,
            column: 19
          },
          end: {
            line: 525,
            column: 29
          }
        }, {
          start: {
            line: 525,
            column: 33
          },
          end: {
            line: 525,
            column: 44
          }
        }],
        line: 525
      },
      "61": {
        loc: {
          start: {
            line: 561,
            column: 24
          },
          end: {
            line: 563,
            column: 32
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 562,
            column: 28
          },
          end: {
            line: 562,
            column: 53
          }
        }, {
          start: {
            line: 563,
            column: 28
          },
          end: {
            line: 563,
            column: 32
          }
        }],
        line: 561
      },
      "62": {
        loc: {
          start: {
            line: 561,
            column: 24
          },
          end: {
            line: 561,
            column: 97
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 561,
            column: 24
          },
          end: {
            line: 561,
            column: 48
          }
        }, {
          start: {
            line: 561,
            column: 52
          },
          end: {
            line: 561,
            column: 97
          }
        }],
        line: 561
      },
      "63": {
        loc: {
          start: {
            line: 569,
            column: 19
          },
          end: {
            line: 569,
            column: 92
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 569,
            column: 19
          },
          end: {
            line: 569,
            column: 63
          }
        }, {
          start: {
            line: 569,
            column: 67
          },
          end: {
            line: 569,
            column: 77
          }
        }, {
          start: {
            line: 569,
            column: 81
          },
          end: {
            line: 569,
            column: 92
          }
        }],
        line: 569
      },
      "64": {
        loc: {
          start: {
            line: 570,
            column: 19
          },
          end: {
            line: 589,
            column: 19
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 570,
            column: 19
          },
          end: {
            line: 570,
            column: 63
          }
        }, {
          start: {
            line: 571,
            column: 20
          },
          end: {
            line: 588,
            column: 31
          }
        }],
        line: 570
      },
      "65": {
        loc: {
          start: {
            line: 582,
            column: 26
          },
          end: {
            line: 584,
            column: 34
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 583,
            column: 30
          },
          end: {
            line: 583,
            column: 55
          }
        }, {
          start: {
            line: 584,
            column: 30
          },
          end: {
            line: 584,
            column: 34
          }
        }],
        line: 582
      },
      "66": {
        loc: {
          start: {
            line: 582,
            column: 26
          },
          end: {
            line: 582,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 582,
            column: 26
          },
          end: {
            line: 582,
            column: 50
          }
        }, {
          start: {
            line: 582,
            column: 54
          },
          end: {
            line: 582,
            column: 93
          }
        }],
        line: 582
      },
      "67": {
        loc: {
          start: {
            line: 591,
            column: 19
          },
          end: {
            line: 604,
            column: 21
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 591,
            column: 19
          },
          end: {
            line: 591,
            column: 32
          }
        }, {
          start: {
            line: 592,
            column: 20
          },
          end: {
            line: 592,
            column: 51
          }
        }, {
          start: {
            line: 593,
            column: 22
          },
          end: {
            line: 603,
            column: 33
          }
        }],
        line: 591
      },
      "68": {
        loc: {
          start: {
            line: 600,
            column: 37
          },
          end: {
            line: 600,
            column: 96
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 600,
            column: 64
          },
          end: {
            line: 600,
            column: 89
          }
        }, {
          start: {
            line: 600,
            column: 92
          },
          end: {
            line: 600,
            column: 96
          }
        }],
        line: 600
      },
      "69": {
        loc: {
          start: {
            line: 607,
            column: 13
          },
          end: {
            line: 607,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 607,
            column: 13
          },
          end: {
            line: 607,
            column: 23
          }
        }, {
          start: {
            line: 607,
            column: 27
          },
          end: {
            line: 607,
            column: 38
          }
        }],
        line: 607
      },
      "70": {
        loc: {
          start: {
            line: 611,
            column: 35
          },
          end: {
            line: 611,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 611,
            column: 35
          },
          end: {
            line: 611,
            column: 43
          }
        }, {
          start: {
            line: 611,
            column: 47
          },
          end: {
            line: 611,
            column: 79
          }
        }],
        line: 611
      },
      "71": {
        loc: {
          start: {
            line: 617,
            column: 33
          },
          end: {
            line: 617,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 617,
            column: 46
          },
          end: {
            line: 617,
            column: 68
          }
        }, {
          start: {
            line: 617,
            column: 71
          },
          end: {
            line: 617,
            column: 75
          }
        }],
        line: 617
      },
      "72": {
        loc: {
          start: {
            line: 618,
            column: 33
          },
          end: {
            line: 618,
            column: 78
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 618,
            column: 46
          },
          end: {
            line: 618,
            column: 71
          }
        }, {
          start: {
            line: 618,
            column: 74
          },
          end: {
            line: 618,
            column: 78
          }
        }],
        line: 618
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0, 0],
      "6": [0, 0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0, 0],
      "12": [0, 0, 0],
      "13": [0, 0],
      "14": [0, 0, 0],
      "15": [0, 0, 0, 0],
      "16": [0, 0, 0],
      "17": [0, 0, 0, 0],
      "18": [0, 0, 0],
      "19": [0, 0, 0],
      "20": [0, 0, 0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0, 0, 0],
      "28": [0, 0, 0],
      "29": [0, 0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0],
      "52": [0, 0],
      "53": [0, 0],
      "54": [0, 0],
      "55": [0, 0, 0],
      "56": [0, 0],
      "57": [0, 0],
      "58": [0, 0, 0, 0],
      "59": [0, 0, 0],
      "60": [0, 0],
      "61": [0, 0],
      "62": [0, 0],
      "63": [0, 0, 0],
      "64": [0, 0],
      "65": [0, 0],
      "66": [0, 0],
      "67": [0, 0, 0],
      "68": [0, 0],
      "69": [0, 0],
      "70": [0, 0],
      "71": [0, 0],
      "72": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b8c981f16f17156dbdfbcb5897b38124c6c83a38"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_m03nq9vsc = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_m03nq9vsc();
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var _ref = (cov_m03nq9vsc().s[0]++, _stylingConstants.default),
  mediaQueries = _ref.mediaQueries,
  sizes = _ref.sizes;
cov_m03nq9vsc().s[1]++;
var isHexColor = function isHexColor(color) {
  cov_m03nq9vsc().f[0]++;
  cov_m03nq9vsc().s[2]++;
  return (cov_m03nq9vsc().b[0][0]++, color) && (cov_m03nq9vsc().b[0][1]++, /^#\w{3,6}$/i.test(color));
};
cov_m03nq9vsc().s[3]++;
var getHex = function getHex(color) {
  cov_m03nq9vsc().f[1]++;
  cov_m03nq9vsc().s[4]++;
  if (!isHexColor(color)) {
    cov_m03nq9vsc().b[1][0]++;
    cov_m03nq9vsc().s[5]++;
    return color;
  } else {
    cov_m03nq9vsc().b[1][1]++;
  }
  cov_m03nq9vsc().s[6]++;
  if (/^#\w{6}$/i.test(color)) {
    cov_m03nq9vsc().b[2][0]++;
    cov_m03nq9vsc().s[7]++;
    return color.toString().toLowerCase();
  } else {
    cov_m03nq9vsc().b[2][1]++;
    cov_m03nq9vsc().s[8]++;
    if (/^#\w{3}$/i.test(color)) {
      cov_m03nq9vsc().b[3][0]++;
      cov_m03nq9vsc().s[9]++;
      return "#".concat(color[1]).concat(color[1]).concat(color[2]).concat(color[2]).concat(color[3]).concat(color[3]).toLowerCase();
    } else {
      cov_m03nq9vsc().b[3][1]++;
    }
  }
  cov_m03nq9vsc().s[10]++;
  return "#".concat(color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+\.?\d*))?\)$/).slice(1).map(function (n, i) {
    cov_m03nq9vsc().f[2]++;
    cov_m03nq9vsc().s[11]++;
    return (i === 3 ? (cov_m03nq9vsc().b[4][0]++, Math.round((0, _parseFloat2.default)(n) * 255)) : (cov_m03nq9vsc().b[4][1]++, (0, _parseFloat2.default)(n))).toString(16).padStart(2, '0').replace('NaN', '');
  }).join(''));
};
cov_m03nq9vsc().s[12]++;
var getBackgroundColor = function getBackgroundColor(props) {
  cov_m03nq9vsc().f[3]++;
  cov_m03nq9vsc().s[13]++;
  return (cov_m03nq9vsc().b[5][0]++, props.theme) && (cov_m03nq9vsc().b[5][1]++, props.theme.backgroundColor) || (cov_m03nq9vsc().b[5][2]++, '#FFFFFF');
};
cov_m03nq9vsc().s[14]++;
var getSignInTextColor = function getSignInTextColor(props) {
  cov_m03nq9vsc().f[4]++;
  cov_m03nq9vsc().s[15]++;
  return (cov_m03nq9vsc().b[6][0]++, props.theme.tsHeader) && (cov_m03nq9vsc().b[6][1]++, props.theme.tsHeader.textColor) || (cov_m03nq9vsc().b[6][2]++, props.theme.textColor);
};
var USER_INFO_CLASS_NAME = (cov_m03nq9vsc().s[16]++, 'stx-UserInfo');
var USER_INFO_ID = (cov_m03nq9vsc().s[17]++, 'stx-UserInfo-id');
var DESKTOP_CLOSE_DIALOG_BTN = (cov_m03nq9vsc().s[18]++, 'stx-desktopCloseDialogBtn');
var KEY_CODE = (cov_m03nq9vsc().s[19]++, {
  TAB: 9
});
var Wrapper = (cov_m03nq9vsc().s[20]++, _styledComponents.default.div.attrs({
  className: 'ts-MobileMenu',
  id: 'ts-MobileMenu',
  role: 'dialog',
  'aria-describedby': 'ts-MobileMenuDescription',
  'aria-labelledby': 'ts-MobileMenuDescription',
  tabindex: 0
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  background: ", ";\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: ", ";\n  align-items: center;\n  justify-content: center;\n  overflow-y: scroll;\n\n  // In order for mobile menu to overlap body content elements, z-index have to be higher than these elements\n  // Should match with the mobile menu z-index (gravity/HeaderStyles)\n  ", ";\n"])), getBackgroundColor, function (props) {
  cov_m03nq9vsc().f[5]++;
  cov_m03nq9vsc().s[21]++;
  return props.open ? (cov_m03nq9vsc().b[7][0]++, 'flex') : (cov_m03nq9vsc().b[7][1]++, 'none');
}, mediaQueries.tablet(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n    display: flex;\n    position: absolute;\n    top: 4rem;\n    right: 2rem;\n    left: auto;\n    bottom: auto;\n    align-items: initial;\n    z-index: 4;\n    width: 12.5rem;\n    flex-direction: column;\n    padding: 0.5rem;\n    border: 1px solid black;\n    overflow-y: auto;\n    visibility: ", ";\n  "])), function (props) {
  cov_m03nq9vsc().f[6]++;
  cov_m03nq9vsc().s[22]++;
  return props.open ? (cov_m03nq9vsc().b[8][0]++, 'visible') : (cov_m03nq9vsc().b[8][1]++, 'hidden');
})));
var MobileMenuDescription = (cov_m03nq9vsc().s[23]++, _styledComponents.default.p.attrs({
  id: 'ts-MobileMenuDescription',
  'aria-hidden': 'true'
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  left: -999px;\n  width: 1px;\n  height: 1px;\n"]))));
var Divider = (cov_m03nq9vsc().s[24]++, _styledComponents.default.hr.attrs({
  className: 'ts-Divider'
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  box-sizing: content-box;\n  height: 0.125rem;\n  overflow: visible;\n  display: block;\n  margin: 0.2rem 0;\n  border: 0;\n  ", " text-align: center;\n  -webkit-tap-highlight-color: transparent;\n"])), function (props) {
  cov_m03nq9vsc().f[7]++;
  cov_m03nq9vsc().s[25]++;
  return "\n    background: ".concat((cov_m03nq9vsc().b[9][0]++, props.theme) && (cov_m03nq9vsc().b[9][1]++, (0, _polished.darken)(0.1, (cov_m03nq9vsc().b[10][0]++, isHexColor(props.theme.productNameTextColor)) && (cov_m03nq9vsc().b[10][1]++, props.theme.productNameTextColor))), ";\n  ");
}));
var MobileMenuCloseIcon = (cov_m03nq9vsc().s[26]++, (0, _styledComponents.default)(_icon.default)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  border-radius: 10px;\n  border: 1px solid;\n  width: 30px;\n  height: 20px;\n  ", ";\n"])), function (props) {
  cov_m03nq9vsc().f[8]++;
  cov_m03nq9vsc().s[27]++;
  return (cov_m03nq9vsc().b[11][0]++, props.theme) && (cov_m03nq9vsc().b[11][1]++, props.theme.linkTextColor) || (cov_m03nq9vsc().b[11][2]++, props.theme.textColor);
}, mediaQueries.tablet(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n    display: none;\n  "])))));
var DesktopDialogCloseBtn = (cov_m03nq9vsc().s[28]++, (0, _styledComponents.default)(_icon.default)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n  display: none;\n  ", ";\n"])), mediaQueries.tablet(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n    display: inline-block;\n    color: ", ";\n    width: 30px;\n    height: 20px;\n  "])), function (props) {
  cov_m03nq9vsc().f[9]++;
  cov_m03nq9vsc().s[29]++;
  return (cov_m03nq9vsc().b[12][0]++, props.theme) && (cov_m03nq9vsc().b[12][1]++, props.theme.productNameTextColor) || (cov_m03nq9vsc().b[12][2]++, props.theme.textColor);
})));
var Section = (cov_m03nq9vsc().s[30]++, _styledComponents.default.div(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n  padding: 0.5rem;\n  font-size: 1rem;\n\n  & + & {\n    margin-top: 1rem;\n  }\n"]))));
var SectionSecondary = (cov_m03nq9vsc().s[31]++, (0, _styledComponents.default)(Section)(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 0.875rem;\n  text-align: ", ";\n"])), function (props) {
  cov_m03nq9vsc().f[10]++;
  cov_m03nq9vsc().s[32]++;
  return props.isCentered ? (cov_m03nq9vsc().b[13][0]++, 'center') : (cov_m03nq9vsc().b[13][1]++, 'left');
}));
var SectionCenter = (cov_m03nq9vsc().s[33]++, (0, _styledComponents.default)(Section)(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n\n  & + & {\n    margin-top: 0.5rem;\n  }\n"]))));
var MenuItem = (cov_m03nq9vsc().s[34]++, _styledComponents.default.div(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2.default)(["\n  padding: 0.25rem 0;\n"]))));
var Title = (cov_m03nq9vsc().s[35]++, _styledComponents.default.div(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 1.25rem;\n  color: ", ";\n  &:hover,\n  &:focus {\n    color: ", ";\n  }\n"])), function (props) {
  cov_m03nq9vsc().f[11]++;
  cov_m03nq9vsc().s[36]++;
  return (cov_m03nq9vsc().b[14][0]++, props.theme) && (cov_m03nq9vsc().b[14][1]++, props.theme.productNameTextColor) || (cov_m03nq9vsc().b[14][2]++, props.theme.textColor);
}, function (props) {
  cov_m03nq9vsc().f[12]++;
  cov_m03nq9vsc().s[37]++;
  return (cov_m03nq9vsc().b[15][0]++, props.theme.button) && (cov_m03nq9vsc().b[15][1]++, props.theme.button.backgroundColor) || (cov_m03nq9vsc().b[15][2]++, props.theme.textColor) || (cov_m03nq9vsc().b[15][3]++, '#000');
}));
var Header = (cov_m03nq9vsc().s[38]++, _styledComponents.default.div(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  padding: 0.5rem 2rem;\n  display: flex;\n  min-height: 3rem;\n  justify-content: flex-end;\n  ", ";\n"])), mediaQueries.tablet(_templateObject15 || (_templateObject15 = (0, _taggedTemplateLiteral2.default)(["\n    display: none;\n  "])))));
var Subtitle = (cov_m03nq9vsc().s[39]++, _styledComponents.default.div(_templateObject16 || (_templateObject16 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 0.875rem;\n  color: ", ";\n  &:hover,\n  &:focus {\n    color: ", ";\n  }\n  padding: 0.25rem 0;\n  max-width: 80vw;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"])), function (props) {
  cov_m03nq9vsc().f[13]++;
  cov_m03nq9vsc().s[40]++;
  return (cov_m03nq9vsc().b[16][0]++, props.theme) && (cov_m03nq9vsc().b[16][1]++, props.theme.productNameTextColor) || (cov_m03nq9vsc().b[16][2]++, props.theme.textColor);
}, function (props) {
  cov_m03nq9vsc().f[14]++;
  cov_m03nq9vsc().s[41]++;
  return (cov_m03nq9vsc().b[17][0]++, props.theme.button) && (cov_m03nq9vsc().b[17][1]++, props.theme.button.backgroundColor) || (cov_m03nq9vsc().b[17][2]++, props.theme.textColor) || (cov_m03nq9vsc().b[17][3]++, '#000');
}));
var Heading = (cov_m03nq9vsc().s[42]++, _styledComponents.default.div(_templateObject17 || (_templateObject17 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  font-weight: 400;\n  color: ", ";\n  padding: 0.5rem 0;\n"])), function (props) {
  cov_m03nq9vsc().f[15]++;
  cov_m03nq9vsc().s[43]++;
  return (cov_m03nq9vsc().b[18][0]++, props.theme.textColor) || (cov_m03nq9vsc().b[18][1]++, props.theme.tsHeader) && (cov_m03nq9vsc().b[18][2]++, props.theme.tsHeader.textColor);
}));
var MobileMenuLink = (cov_m03nq9vsc().s[44]++, (0, _styledComponents.default)(_link.default)(_templateObject18 || (_templateObject18 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n\n  &:hover,\n  &:focus {\n    color: ", ";\n  }\n"])), function (props) {
  cov_m03nq9vsc().f[16]++;
  cov_m03nq9vsc().s[45]++;
  return (cov_m03nq9vsc().b[19][0]++, props.theme) && (cov_m03nq9vsc().b[19][1]++, props.theme.linkTextColor) || (cov_m03nq9vsc().b[19][2]++, props.theme.textColor);
}, function (props) {
  cov_m03nq9vsc().f[17]++;
  cov_m03nq9vsc().s[46]++;
  return (cov_m03nq9vsc().b[20][0]++, props.theme.button) && (cov_m03nq9vsc().b[20][1]++, props.theme.button.backgroundColor) || (cov_m03nq9vsc().b[20][2]++, props.theme.textColor) || (cov_m03nq9vsc().b[20][3]++, '#000');
}));
var SignInButton = (cov_m03nq9vsc().s[47]++, (0, _styledComponents.default)(_button.default)(_templateObject19 || (_templateObject19 = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n\n  &:hover,\n  &:focus {\n    color: ", ";\n  }\n  margin-right: 0.5em;\n"])), getSignInTextColor, (cov_m03nq9vsc().b[21][0]++, getSignInTextColor) || (cov_m03nq9vsc().b[21][1]++, '#fff')));
var CloseDialogBtnWrapper = (cov_m03nq9vsc().s[48]++, _styledComponents.default.div(_templateObject20 || (_templateObject20 = (0, _taggedTemplateLiteral2.default)(["\n  display: none;\n  ", ";\n"])), mediaQueries.tablet(_templateObject21 || (_templateObject21 = (0, _taggedTemplateLiteral2.default)(["\n    display: flex;\n    justify-content: center;\n  "])))));
var OutsideAlerter = (cov_m03nq9vsc().s[49]++, _styledComponents.default.div(_templateObject22 || (_templateObject22 = (0, _taggedTemplateLiteral2.default)([""]))));
var LotteryHistoryContainer = (cov_m03nq9vsc().s[50]++, _styledComponents.default.div(_templateObject23 || (_templateObject23 = (0, _taggedTemplateLiteral2.default)(["\n  padding-top: 0.25rem;\n"]))));
function debounce(fn, delay) {
  cov_m03nq9vsc().f[18]++;
  var timer = (cov_m03nq9vsc().s[51]++, null);
  // eslint-disable-next-line func-names
  cov_m03nq9vsc().s[52]++;
  return function () {
    cov_m03nq9vsc().f[19]++;
    var context = (cov_m03nq9vsc().s[53]++, this);
    // eslint-disable-next-line prefer-rest-params
    var args = (cov_m03nq9vsc().s[54]++, arguments);
    cov_m03nq9vsc().s[55]++;
    clearTimeout(timer);
    cov_m03nq9vsc().s[56]++;
    timer = setTimeout(function () {
      cov_m03nq9vsc().f[20]++;
      cov_m03nq9vsc().s[57]++;
      fn.apply(context, args);
    }, delay);
  };
}
var MobileMenu = /*#__PURE__*/function (_React$PureComponent) {
  function MobileMenu(props) {
    var _this;
    (0, _classCallCheck2.default)(this, MobileMenu);
    cov_m03nq9vsc().f[21]++;
    cov_m03nq9vsc().s[58]++;
    _this = _callSuper(this, MobileMenu, [props]);
    (0, _defineProperty2.default)(_this, "handleCloseBtnKey", (cov_m03nq9vsc().s[84]++, function (event) {
      cov_m03nq9vsc().f[28]++;
      var _ref2 = (cov_m03nq9vsc().s[85]++, _this.state),
        isMobile = _ref2.isMobile;
      var _ref3 = (cov_m03nq9vsc().s[86]++, _this.props),
        config = _ref3.config;
      var showCommunityTicketsLink = (cov_m03nq9vsc().s[87]++, (cov_m03nq9vsc().b[28][0]++, config) && (cov_m03nq9vsc().b[28][1]++, config.config) && (cov_m03nq9vsc().b[28][2]++, config.config.showCommunityTicketsLink));
      var purchaseOnBehalfEnabled = (cov_m03nq9vsc().s[88]++, (cov_m03nq9vsc().b[29][0]++, config) && (cov_m03nq9vsc().b[29][1]++, config.configuration) && (cov_m03nq9vsc().b[29][2]++, config.configuration.purchaseOnBehalfEnabled));
      // We have two close buttons, one on top for mobile menu, one for desktop to make it easier to implement trap focus
      // [TODO] it's better to have a consistent design that we can reuse for both screens
      // Current menu item order on DESKTOP is:
      // 1. User info (name, email, ...)
      // 2. Family and Friends
      // 3. Community Ticket
      // 4. Product links
      // 5. Close button
      cov_m03nq9vsc().s[89]++;
      if (!isMobile) {
        cov_m03nq9vsc().b[30][0]++;
        cov_m03nq9vsc().s[90]++;
        if ((cov_m03nq9vsc().b[32][0]++, !event.shiftKey) && (cov_m03nq9vsc().b[32][1]++, event.keyCode === KEY_CODE.TAB)) {
          cov_m03nq9vsc().b[31][0]++;
          cov_m03nq9vsc().s[91]++;
          if (_this.userInfoRef.current) {
            cov_m03nq9vsc().b[33][0]++;
            cov_m03nq9vsc().s[92]++;
            // Use event loop to set focus to first element.
            setTimeout(function () {
              cov_m03nq9vsc().f[29]++;
              cov_m03nq9vsc().s[93]++;
              _this.userInfoRef.current.focus();
            }, 0);
          } else {
            cov_m03nq9vsc().b[33][1]++;
          }
        } else {
          cov_m03nq9vsc().b[31][1]++;
        }
      } else {
        cov_m03nq9vsc().b[30][1]++;
        cov_m03nq9vsc().s[94]++;
        if ((cov_m03nq9vsc().b[35][0]++, isMobile) && (cov_m03nq9vsc().b[35][1]++, event.shiftKey) && (cov_m03nq9vsc().b[35][2]++, event.keyCode === KEY_CODE.TAB)) {
          cov_m03nq9vsc().b[34][0]++;
          var _ref4 = (cov_m03nq9vsc().s[95]++, _this.props),
            customLinks = _ref4.customLinks,
            user = _ref4.user;
          // Current menu item order on MOBILE is:
          // 1. Close button
          // 2. Login: User info (name, email, ...)
          // 3. Family and Friends
          // 4. Community Ticket
          // 5. Product links
          var lastNavigationItem = (cov_m03nq9vsc().s[96]++, null);
          var isSignedIn = (cov_m03nq9vsc().s[97]++, (cov_m03nq9vsc().b[36][0]++, user) && (cov_m03nq9vsc().b[36][1]++, (0, _keys.default)(user).length > 0));
          cov_m03nq9vsc().s[98]++;
          if ((cov_m03nq9vsc().b[38][0]++, customLinks) && (cov_m03nq9vsc().b[38][1]++, customLinks.length > 0)) {
            cov_m03nq9vsc().b[37][0]++;
            cov_m03nq9vsc().s[99]++;
            lastNavigationItem = _this.lastCustomLinkRef;
          } else {
            cov_m03nq9vsc().b[37][1]++;
            cov_m03nq9vsc().s[100]++;
            if (showCommunityTicketsLink) {
              cov_m03nq9vsc().b[39][0]++;
              cov_m03nq9vsc().s[101]++;
              lastNavigationItem = _this.communityTicketRef;
            } else {
              cov_m03nq9vsc().b[39][1]++;
              cov_m03nq9vsc().s[102]++;
              if (purchaseOnBehalfEnabled) {
                cov_m03nq9vsc().b[40][0]++;
                cov_m03nq9vsc().s[103]++;
                lastNavigationItem = _this.friendAndFamilyRef;
              } else {
                cov_m03nq9vsc().b[40][1]++;
                cov_m03nq9vsc().s[104]++;
                if (isSignedIn) {
                  cov_m03nq9vsc().b[41][0]++;
                  cov_m03nq9vsc().s[105]++;
                  lastNavigationItem = _this.signOutButtonRef;
                } else {
                  cov_m03nq9vsc().b[41][1]++;
                  cov_m03nq9vsc().s[106]++;
                  lastNavigationItem = _this.registerButtonRef;
                }
              }
            }
          }
          cov_m03nq9vsc().s[107]++;
          if (lastNavigationItem.current) {
            cov_m03nq9vsc().b[42][0]++;
            cov_m03nq9vsc().s[108]++;
            // Use event loop to set focus to first element.
            setTimeout(function () {
              cov_m03nq9vsc().f[30]++;
              cov_m03nq9vsc().s[109]++;
              lastNavigationItem.current.focus();
            }, 0);
          } else {
            cov_m03nq9vsc().b[42][1]++;
          }
        } else {
          cov_m03nq9vsc().b[34][1]++;
        }
      }
    }));
    (0, _defineProperty2.default)(_this, "handleUserInfoKey", (cov_m03nq9vsc().s[110]++, function (event) {
      cov_m03nq9vsc().f[31]++;
      cov_m03nq9vsc().s[111]++;
      if ((cov_m03nq9vsc().b[44][0]++, event.shiftKey) && (cov_m03nq9vsc().b[44][1]++, event.keyCode === KEY_CODE.TAB)) {
        cov_m03nq9vsc().b[43][0]++;
        cov_m03nq9vsc().s[112]++;
        if (_this.closeDialogBtnDesktopRef.current) {
          cov_m03nq9vsc().b[45][0]++;
          cov_m03nq9vsc().s[113]++;
          // Use event loop to set focus.
          setTimeout(function () {
            cov_m03nq9vsc().f[32]++;
            cov_m03nq9vsc().s[114]++;
            _this.closeDialogBtnDesktopRef.current.focus();
          }, 0);
        } else {
          cov_m03nq9vsc().b[45][1]++;
        }
      } else {
        cov_m03nq9vsc().b[43][1]++;
      }
    }));
    (0, _defineProperty2.default)(_this, "handleLastElementKey", (cov_m03nq9vsc().s[115]++, function (event) {
      cov_m03nq9vsc().f[33]++;
      cov_m03nq9vsc().s[116]++;
      // implement trap focus
      if ((cov_m03nq9vsc().b[47][0]++, !event.shiftKey) && (cov_m03nq9vsc().b[47][1]++, event.keyCode === KEY_CODE.TAB)) {
        cov_m03nq9vsc().b[46][0]++;
        cov_m03nq9vsc().s[117]++;
        if (_this.closeDialogBtnMobileRef.current) {
          cov_m03nq9vsc().b[48][0]++;
          cov_m03nq9vsc().s[118]++;
          // Use event loop to set focus.
          setTimeout(function () {
            cov_m03nq9vsc().f[34]++;
            cov_m03nq9vsc().s[119]++;
            _this.closeDialogBtnMobileRef.current.focus();
          }, 0);
        } else {
          cov_m03nq9vsc().b[48][1]++;
        }
      } else {
        cov_m03nq9vsc().b[46][1]++;
      }
    }));
    (0, _defineProperty2.default)(_this, "isSignInButtonFlat", (cov_m03nq9vsc().s[120]++, function () {
      cov_m03nq9vsc().f[35]++;
      cov_m03nq9vsc().s[121]++;
      return getHex(getSignInTextColor(_this.props)) !== getHex(getBackgroundColor(_this.props));
    }));
    cov_m03nq9vsc().s[59]++;
    _this.state = {
      isMobile: false
    };
    cov_m03nq9vsc().s[60]++;
    _this.wrapperRef = /*#__PURE__*/_react.default.createRef();
    cov_m03nq9vsc().s[61]++;
    _this.userInfoRef = /*#__PURE__*/_react.default.createRef();
    cov_m03nq9vsc().s[62]++;
    _this.closeDialogBtnDesktopRef = /*#__PURE__*/_react.default.createRef();
    cov_m03nq9vsc().s[63]++;
    _this.closeDialogBtnMobileRef = /*#__PURE__*/_react.default.createRef();
    cov_m03nq9vsc().s[64]++;
    _this.signOutButtonRef = /*#__PURE__*/_react.default.createRef();
    cov_m03nq9vsc().s[65]++;
    _this.registerButtonRef = /*#__PURE__*/_react.default.createRef();
    cov_m03nq9vsc().s[66]++;
    _this.lastCustomLinkRef = /*#__PURE__*/_react.default.createRef();
    cov_m03nq9vsc().s[67]++;
    _this.friendAndFamilyRef = /*#__PURE__*/_react.default.createRef();
    cov_m03nq9vsc().s[68]++;
    _this.communityTicketRef = /*#__PURE__*/_react.default.createRef();
    cov_m03nq9vsc().s[69]++;
    _this.setWrapperRef = _this.setWrapperRef.bind(_this);
    cov_m03nq9vsc().s[70]++;
    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(MobileMenu, _React$PureComponent);
  return (0, _createClass2.default)(MobileMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_m03nq9vsc().f[22]++;
      cov_m03nq9vsc().s[71]++;
      document.addEventListener('mousedown', this.handleClickOutside);
      cov_m03nq9vsc().s[72]++;
      window.addEventListener('resize', debounce(this.handleResize.bind(this), 100));
      cov_m03nq9vsc().s[73]++;
      this.handleResize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_m03nq9vsc().f[23]++;
      cov_m03nq9vsc().s[74]++;
      document.removeEventListener('mousedown', this.handleClickOutside);
      cov_m03nq9vsc().s[75]++;
      window.removeEventListener('resize', debounce(this.handleResize.bind(this), 100));
    }
  }, {
    key: "setWrapperRef",
    value: function setWrapperRef(node) {
      cov_m03nq9vsc().f[24]++;
      cov_m03nq9vsc().s[76]++;
      this.wrapperRef = node;
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      cov_m03nq9vsc().f[25]++;
      cov_m03nq9vsc().s[77]++;
      this.setState({
        isMobile: window.innerWidth <= ((cov_m03nq9vsc().b[22][0]++, sizes.tablet) || (cov_m03nq9vsc().b[22][1]++, '768'))
      });
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside() {
      cov_m03nq9vsc().f[26]++;
      var isClickedOnMobileMenu = (cov_m03nq9vsc().s[78]++, false);
      cov_m03nq9vsc().s[79]++;
      if ((cov_m03nq9vsc().b[24][0]++, event.path) && (cov_m03nq9vsc().b[24][1]++, event.path.length > 0)) {
        cov_m03nq9vsc().b[23][0]++;
        cov_m03nq9vsc().s[80]++;
        isClickedOnMobileMenu = event.path.some(function (element) {
          cov_m03nq9vsc().f[27]++;
          cov_m03nq9vsc().s[81]++;
          return (cov_m03nq9vsc().b[25][0]++, element.className) && (cov_m03nq9vsc().b[25][1]++, element.className.includes(USER_INFO_CLASS_NAME));
        });
      } else {
        cov_m03nq9vsc().b[23][1]++;
      }
      cov_m03nq9vsc().s[82]++;
      if ((cov_m03nq9vsc().b[27][0]++, this.props.open) && (cov_m03nq9vsc().b[27][1]++, this.wrapperRef) && (cov_m03nq9vsc().b[27][2]++, !this.wrapperRef.current.contains(event.target)) && (cov_m03nq9vsc().b[27][3]++, !isClickedOnMobileMenu)) {
        cov_m03nq9vsc().b[26][0]++;
        cov_m03nq9vsc().s[83]++;
        this.props.toggleMenu();
      } else {
        cov_m03nq9vsc().b[26][1]++;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      cov_m03nq9vsc().f[36]++;
      var _ref5 = (cov_m03nq9vsc().s[122]++, this.state),
        isMobile = _ref5.isMobile;
      var _ref6 = (cov_m03nq9vsc().s[123]++, this.props),
        config = _ref6.config,
        intl = _ref6.intl,
        mobileMenuRef = _ref6.mobileMenuRef,
        user = _ref6.user;
      var _ref7 = (cov_m03nq9vsc().s[124]++, config.configuration),
        baseUrl = _ref7.baseUrl;
      var isSignedIn = (cov_m03nq9vsc().s[125]++, (cov_m03nq9vsc().b[49][0]++, user) && (cov_m03nq9vsc().b[49][1]++, (0, _keys.default)(user).length > 0));
      var customLinks = (cov_m03nq9vsc().s[126]++, (0, _toConsumableArray2.default)(this.props.customLinks).sort(function (a, b) {
        cov_m03nq9vsc().f[37]++;
        cov_m03nq9vsc().s[127]++;
        return a.rank - b.rank;
      }));
      var isGuest = (cov_m03nq9vsc().s[128]++, (cov_m03nq9vsc().b[50][0]++, isSignedIn) && (cov_m03nq9vsc().b[50][1]++, user.guest));
      var message = (cov_m03nq9vsc().s[129]++, {
        closeBtnAltText: intl.formatMessage({
          id: 'gravity.header.mobileMenu.closeIcon.altText'
        }),
        mobileMenuDiaglog: intl.formatMessage({
          id: 'gravity.header.mobileMenu.dialog.description'
        })
      });
      cov_m03nq9vsc().s[130]++;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 419,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement(OutsideAlerter, {
        innerRef: this.wrapperRef,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 420,
          columnNumber: 9
        }
      }, /*#__PURE__*/_react.default.createElement(Wrapper, {
        open: this.props.open,
        innerRef: mobileMenuRef,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 421,
          columnNumber: 11
        }
      }, /*#__PURE__*/_react.default.createElement(MobileMenuDescription, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 422,
          columnNumber: 13
        }
      }, (cov_m03nq9vsc().b[51][0]++, message.mobileMenuDiaglog) || (cov_m03nq9vsc().b[51][1]++, 'Mobile menu dialog')), /*#__PURE__*/_react.default.createElement(Header, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 425,
          columnNumber: 13
        }
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        flat: true,
        large: true,
        onClick: this.props.toggleMenu,
        alt: message.closeBtnAltText,
        onKeyDown: this.handleCloseBtnKey,
        customRef: this.closeDialogBtnMobileRef,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 426,
          columnNumber: 15
        }
      }, /*#__PURE__*/_react.default.createElement(MobileMenuCloseIcon, {
        iconName: "close",
        alt: message.closeBtnAltText,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 433,
          columnNumber: 17
        }
      }))), (cov_m03nq9vsc().b[52][0]++, !isSignedIn) && (cov_m03nq9vsc().b[52][1]++, /*#__PURE__*/_react.default.createElement(SectionCenter, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 437,
          columnNumber: 15
        }
      }, /*#__PURE__*/_react.default.createElement(MenuItem, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 438,
          columnNumber: 17
        }
      }, /*#__PURE__*/_react.default.createElement(SignInButton, {
        href: "".concat(baseUrl, "account/login?lang=").concat(this.props.currentLocale),
        flat: this.isSignInButtonFlat(),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 439,
          columnNumber: 19
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.MobileMenu.signinButton",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 442,
          columnNumber: 21
        }
      })), /*#__PURE__*/_react.default.createElement(_button.default, {
        href: "".concat(baseUrl, "account/register?lang=").concat(this.props.currentLocale),
        customRef: this.registerButtonRef,
        onKeyDown: customLinks.length === 0 ? (cov_m03nq9vsc().b[53][0]++, this.handleLastElementKey) : (cov_m03nq9vsc().b[53][1]++, null),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 444,
          columnNumber: 19
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.MobileMenu.registerButton",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 448,
          columnNumber: 21
        }
      }))))), (cov_m03nq9vsc().b[54][0]++, isGuest) && (cov_m03nq9vsc().b[54][1]++, /*#__PURE__*/_react.default.createElement(Section, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 454,
          columnNumber: 15
        }
      }, /*#__PURE__*/_react.default.createElement(MenuItem, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 455,
          columnNumber: 17
        }
      }, /*#__PURE__*/_react.default.createElement(Title, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 456,
          columnNumber: 19
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 457,
          columnNumber: 21
        }
      }, user.email))), /*#__PURE__*/_react.default.createElement(MenuItem, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 460,
          columnNumber: 17
        }
      }, /*#__PURE__*/_react.default.createElement(MobileMenuLink, {
        href: "".concat(baseUrl, "account/logout?lang=").concat(this.props.currentLocale),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 461,
          columnNumber: 19
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.MobileMenu.accountSignOut",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 463,
          columnNumber: 21
        }
      }))))), (cov_m03nq9vsc().b[55][0]++, isSignedIn) && (cov_m03nq9vsc().b[55][1]++, !isGuest) && (cov_m03nq9vsc().b[55][2]++, /*#__PURE__*/_react.default.createElement(Section, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 470,
          columnNumber: 17
        }
      }, /*#__PURE__*/_react.default.createElement(MenuItem, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 471,
          columnNumber: 19
        }
      }, /*#__PURE__*/_react.default.createElement(MobileMenuLink, {
        key: USER_INFO_ID,
        id: USER_INFO_ID,
        href: "".concat(baseUrl, "account?lang=").concat(this.props.currentLocale),
        customRef: this.userInfoRef,
        onKeyDown: this.handleUserInfoKey,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 472,
          columnNumber: 21
        }
      }, /*#__PURE__*/_react.default.createElement(Title, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 478,
          columnNumber: 23
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 479,
          columnNumber: 25
        }
      }, _he.default.decode(user.firstName)), /*#__PURE__*/_react.default.createElement("span", {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 480,
          columnNumber: 25
        }
      }, " ", _he.default.decode(user.lastName))), (cov_m03nq9vsc().b[56][0]++, user.structureName) && (cov_m03nq9vsc().b[56][1]++, /*#__PURE__*/_react.default.createElement(Subtitle, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 482,
          columnNumber: 46
        }
      }, _he.default.decode(user.structureName))), (cov_m03nq9vsc().b[57][0]++, !user.structureName) && (cov_m03nq9vsc().b[57][1]++, /*#__PURE__*/_react.default.createElement(Subtitle, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 483,
          columnNumber: 47
        }
      }, user.email)))), (cov_m03nq9vsc().b[58][0]++, config.config) && (cov_m03nq9vsc().b[58][1]++, config.config.lotteryHistoryEnabled) && (cov_m03nq9vsc().b[58][2]++, isSignedIn) && (cov_m03nq9vsc().b[58][3]++, /*#__PURE__*/_react.default.createElement(LotteryHistoryContainer, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 489,
          columnNumber: 23
        }
      }, /*#__PURE__*/_react.default.createElement(MenuItem, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 490,
          columnNumber: 25
        }
      }, /*#__PURE__*/_react.default.createElement(MobileMenuLink, {
        href: "".concat(baseUrl, "account/lotteryHistory?lang=").concat(this.props.currentLocale),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 491,
          columnNumber: 27
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.MobileMenu.lotteryHistory",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 495,
          columnNumber: 29
        }
      }))), /*#__PURE__*/_react.default.createElement(Divider, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 498,
          columnNumber: 25
        }
      }))), /*#__PURE__*/_react.default.createElement(MenuItem, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 501,
          columnNumber: 19
        }
      }, /*#__PURE__*/_react.default.createElement(Heading, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 502,
          columnNumber: 21
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.MobileMenu.accountTickets",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 503,
          columnNumber: 23
        }
      })), /*#__PURE__*/_react.default.createElement(MobileMenuLink, {
        href: "".concat(baseUrl, "account/tickets?lang=").concat(this.props.currentLocale),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 505,
          columnNumber: 21
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.MobileMenu.accountTickets",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 507,
          columnNumber: 23
        }
      }))), (cov_m03nq9vsc().b[59][0]++, config.config) && (cov_m03nq9vsc().b[59][1]++, config.config.showSubscriptionsLink) && (cov_m03nq9vsc().b[59][2]++, /*#__PURE__*/_react.default.createElement(MenuItem, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 512,
          columnNumber: 23
        }
      }, /*#__PURE__*/_react.default.createElement(MobileMenuLink, {
        href: "".concat(baseUrl, "account/subscriptions?lang=").concat(this.props.currentLocale),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 513,
          columnNumber: 25
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.MobileMenu.subscriptions",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 515,
          columnNumber: 27
        }
      })))), /*#__PURE__*/_react.default.createElement(MenuItem, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 519,
          columnNumber: 19
        }
      }, /*#__PURE__*/_react.default.createElement(MobileMenuLink, {
        href: "".concat(baseUrl, "account/files?lang=").concat(this.props.currentLocale),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 520,
          columnNumber: 21
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.MobileMenu.accountOrderHistory",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 522,
          columnNumber: 23
        }
      }))), (cov_m03nq9vsc().b[60][0]++, isSignedIn) && (cov_m03nq9vsc().b[60][1]++, /*#__PURE__*/_react.default.createElement(Divider, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 525,
          columnNumber: 34
        }
      })), /*#__PURE__*/_react.default.createElement(MenuItem, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 526,
          columnNumber: 19
        }
      }, /*#__PURE__*/_react.default.createElement(Heading, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 527,
          columnNumber: 21
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.MobileMenu.account",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 528,
          columnNumber: 23
        }
      })), /*#__PURE__*/_react.default.createElement(MobileMenuLink, {
        href: "".concat(baseUrl, "account/advantages?lang=").concat(this.props.currentLocale),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 530,
          columnNumber: 21
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.MobileMenu.accountOffers",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 532,
          columnNumber: 23
        }
      }))), /*#__PURE__*/_react.default.createElement(MenuItem, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 535,
          columnNumber: 19
        }
      }, /*#__PURE__*/_react.default.createElement(MobileMenuLink, {
        href: "".concat(baseUrl, "account/editPersonalDetails?lang=").concat(this.props.currentLocale),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 536,
          columnNumber: 21
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.MobileMenu.accountProfile",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 540,
          columnNumber: 23
        }
      }))), /*#__PURE__*/_react.default.createElement(MenuItem, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 543,
          columnNumber: 19
        }
      }, /*#__PURE__*/_react.default.createElement(MobileMenuLink, {
        href: "".concat(baseUrl, "account/password?lang=").concat(this.props.currentLocale),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 544,
          columnNumber: 21
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.MobileMenu.accountPassword",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 546,
          columnNumber: 23
        }
      }))), /*#__PURE__*/_react.default.createElement(MenuItem, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 549,
          columnNumber: 19
        }
      }, /*#__PURE__*/_react.default.createElement(MobileMenuLink, {
        href: "".concat(baseUrl, "account/addressBook?lang=").concat(this.props.currentLocale),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 550,
          columnNumber: 21
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.MobileMenu.accountAddressBook",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 552,
          columnNumber: 23
        }
      }))), /*#__PURE__*/_react.default.createElement(MenuItem, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 555,
          columnNumber: 19
        }
      }, /*#__PURE__*/_react.default.createElement(MobileMenuLink, {
        href: "".concat(baseUrl, "account/logout?lang=").concat(this.props.currentLocale),
        customRef: this.signOutButtonRef
        // Trap focus implementation: last element will be logout button if custom links list is empty
        ,
        onKeyDown: (cov_m03nq9vsc().b[62][0]++, customLinks.length === 0) && (cov_m03nq9vsc().b[62][1]++, !config.configuration.purchaseOnBehalfEnabled) ? (cov_m03nq9vsc().b[61][0]++, this.handleLastElementKey) : (cov_m03nq9vsc().b[61][1]++, null),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 556,
          columnNumber: 21
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.MobileMenu.accountSignOut",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 565,
          columnNumber: 23
        }
      }))), (cov_m03nq9vsc().b[63][0]++, config.configuration.purchaseOnBehalfEnabled) && (cov_m03nq9vsc().b[63][1]++, isSignedIn) && (cov_m03nq9vsc().b[63][2]++, /*#__PURE__*/_react.default.createElement(Divider, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 569,
          columnNumber: 82
        }
      })), (cov_m03nq9vsc().b[64][0]++, config.configuration.purchaseOnBehalfEnabled) && (cov_m03nq9vsc().b[64][1]++, /*#__PURE__*/_react.default.createElement(MenuItem, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 571,
          columnNumber: 21
        }
      }, /*#__PURE__*/_react.default.createElement(Heading, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 572,
          columnNumber: 23
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.MobileMenu.community",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 573,
          columnNumber: 25
        }
      })), /*#__PURE__*/_react.default.createElement(MobileMenuLink, {
        href: "".concat(baseUrl, "account/community/manageFriendsAndFamily?lang=").concat(this.props.currentLocale),
        customRef: this.friendAndFamilyRef
        // Trap focus implementation: last element will be logout button if custom links list is empty
        ,
        onKeyDown: (cov_m03nq9vsc().b[66][0]++, customLinks.length === 0) && (cov_m03nq9vsc().b[66][1]++, !config.config.showCommunityTicketsLink) ? (cov_m03nq9vsc().b[65][0]++, this.handleLastElementKey) : (cov_m03nq9vsc().b[65][1]++, null),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 575,
          columnNumber: 23
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.MobileMenu.friendAndFamily",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 586,
          columnNumber: 25
        }
      })))), (cov_m03nq9vsc().b[67][0]++, config.config) && (cov_m03nq9vsc().b[67][1]++, config.showCommunityTicketsLink) && (cov_m03nq9vsc().b[67][2]++, /*#__PURE__*/_react.default.createElement(MenuItem, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 593,
          columnNumber: 23
        }
      }, /*#__PURE__*/_react.default.createElement(MobileMenuLink, {
        href: "".concat(baseUrl, "account/community/reservationTickets?lang=").concat(this.props.currentLocale),
        customRef: this.communityTicketRef
        // Trap focus implementation: last element will be logout button if custom links list is empty
        ,
        onKeyDown: customLinks.length === 0 ? (cov_m03nq9vsc().b[68][0]++, this.handleLastElementKey) : (cov_m03nq9vsc().b[68][1]++, null),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 594,
          columnNumber: 25
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.MobileMenu.reservationTickets",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 601,
          columnNumber: 27
        }
      })))))), (cov_m03nq9vsc().b[69][0]++, isSignedIn) && (cov_m03nq9vsc().b[69][1]++, /*#__PURE__*/_react.default.createElement(Divider, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 607,
          columnNumber: 28
        }
      })), /*#__PURE__*/_react.default.createElement(SectionSecondary, {
        isCentered: !isSignedIn,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 608,
          columnNumber: 13
        }
      }, customLinks.map(function (link, index) {
        cov_m03nq9vsc().f[38]++;
        // Trap focus implementation: Custom link is last item on mobile but not on desktop
        var isLastItem = (cov_m03nq9vsc().s[131]++, (cov_m03nq9vsc().b[70][0]++, isMobile) && (cov_m03nq9vsc().b[70][1]++, customLinks.length === index + 1));
        cov_m03nq9vsc().s[132]++;
        return /*#__PURE__*/_react.default.createElement(MenuItem, {
          key: (0, _utils.uuid)('tsMobileMenu-item'),
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 613,
            columnNumber: 19
          }
        }, /*#__PURE__*/_react.default.createElement(MobileMenuLink, {
          href: link.url,
          key: (0, _utils.uuid)('tsMobileMenu-item-link'),
          customRef: isLastItem ? (cov_m03nq9vsc().b[71][0]++, _this2.lastCustomLinkRef) : (cov_m03nq9vsc().b[71][1]++, null),
          onKeyDown: isLastItem ? (cov_m03nq9vsc().b[72][0]++, _this2.handleLastElementKey) : (cov_m03nq9vsc().b[72][1]++, null),
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 614,
            columnNumber: 21
          }
        }, /*#__PURE__*/_react.default.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: link.name
          },
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 619,
            columnNumber: 23
          }
        })));
      })), /*#__PURE__*/_react.default.createElement(CloseDialogBtnWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 626,
          columnNumber: 13
        }
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        flat: true,
        large: true,
        onClick: this.props.toggleMenu,
        alt: message.closeBtnAltText,
        id: DESKTOP_CLOSE_DIALOG_BTN,
        onKeyDown: this.handleCloseBtnKey,
        customRef: this.closeDialogBtnDesktopRef,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 627,
          columnNumber: 15
        }
      }, /*#__PURE__*/_react.default.createElement(DesktopDialogCloseBtn, {
        iconName: "close",
        alt: message.closeBtnAltText,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 635,
          columnNumber: 17
        }
      }))))));
    }
  }]);
}((_react.default.PureComponent));
cov_m03nq9vsc().s[133]++;
MobileMenu.propTypes = {
  currentLocale: _propTypes.default.string,
  defaultLocale: _propTypes.default.string,
  config: _config.ConfigType.isRequired,
  user: _propTypes.default.shape(_config.UserInfoType),
  /** Theme provided by styled components */
  theme: _propTypes.default.objectOf(_propTypes.default.string).isRequired,
  customLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    rank: _propTypes.default.number.isRequired,
    style: _propTypes.default.string.isRequired,
    name: _propTypes.default.objectOf(_propTypes.default.string).isRequired,
    url: _propTypes.default.objectOf(_propTypes.default.string).isRequired
  })),
  open: _propTypes.default.bool,
  toggleMenu: _propTypes.default.func,
  /** function that will be called on change locale */
  changeLocale: _propTypes.default.func.isRequired,
  intl: _reactIntl.intlShape.isRequired,
  mobileMenuRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.any
  })])
};
cov_m03nq9vsc().s[134]++;
MobileMenu.defaultProps = {
  currentLocale: 'en',
  user: {},
  defaultLocale: '',
  customLinks: [],
  open: false,
  toggleMenu: function toggleMenu() {
    cov_m03nq9vsc().f[39]++;
  },
  mobileMenuRef: function mobileMenuRef() {
    cov_m03nq9vsc().f[40]++;
  }
};
var _default = exports.default = (0, _reactIntl.injectIntl)((0, _styledComponents.withTheme)(MobileMenu));